const getTitle = (document, {titleIndex}) => {
    return document.content[titleIndex];
}

export default getTitle;